module.exports = __webpack_public_path__ + "img/two_left.8bcb12f8.png";